import { useTheme } from '@emotion/react';
import { Box, styled, useMediaQuery } from '@mui/material';
import MenuContent from './MenuContent';

// const navbarHeight = 77;

const StyledCard = styled(Box)(({}) => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#ffffff',
}));

export default function MenuPanel() {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  if (isTablet) return null;

  return (
    <StyledCard
      sx={{
        width: '100%',
        backgroundColor: theme.palette.primary.white,
      }}
    >
      <Box
        sx={{
          height: '100%',
          overflow: 'auto',
        }}
      >
        <MenuContent />
      </Box>
    </StyledCard>
  );
}
